import React from 'react';

import i18n from '../../i18n';

// @mui
import { TableCell } from '@mui/material';
import Label from '../../components/label';

// Text, Number, Items cells are similar
export default class GridEnableCell extends React.Component {
    render() {
        // props: value, id, field
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                <Label color={this.props.value ? 'success' : 'error'}>
                    {i18n.t(`enums.${this.props.value ? 'enabled' : 'disabled'}`)}
                </Label>
            </TableCell>
        );
    }
}
